import { ReactElement, useEffect, FC } from 'react';
import I18n from 'i18next';
import Cookies from 'universal-cookie';
import { I18nextProvider, initReactI18next } from 'react-i18next';

import us from '../i18n/us.json';

I18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: 'us',
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
  load: 'languageOnly',
  nsSeparator: false,
  pluralSeparator: '_',
  resources: {
    us: { translation: us },
  },
  returnNull: false,
});

export const I18nProvider: FC<{
  children: ReactElement | ReactElement[];
  lang: string | undefined;
}> = ({ children, lang }): React.ReactElement => {
  useEffect(() => {
    const cookies = new Cookies();
    I18n.changeLanguage(lang || cookies.get('vc_bo_lng'));
  }, [lang]);
  return <I18nextProvider i18n={I18n}>{children}</I18nextProvider>;
};
